import { render, staticRenderFns } from "./WorkflowsNew.vue?vue&type=template&id=98ebdcd6&"
import script from "./WorkflowsNew.vue?vue&type=script&lang=js&"
export * from "./WorkflowsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports